import script from "./Education.vue?vue&type=script&setup=true&lang=js"
export * from "./Education.vue?vue&type=script&setup=true&lang=js"

import "./Education.vue?vue&type=style&index=0&id=93ba4102&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93ba4102"]])

export default __exports__